(function ( $) {

    $(document).on('ready', function () {
        var isMobileOrTablet = $('#to-check-if-responsive:visible').length > 0;
        var viewportHeight = document.documentElement.clientHeight;

        var controller = new ScrollMagic.Controller();

        if ( !isMobileOrTablet ) {
            $('.slanted-wrapper').each(function () {
                var $this = $(this);
                var scene = new ScrollMagic.Scene({
                    triggerElement: $this.get(0),
                    // if block's height is more than 90% of viewport height (on desktop) - increasing duration to be equal to 110% of this block for current ScrollMagic.Scene
                    duration: $this.outerHeight(true) > viewportHeight * 0.9 ? $this.outerHeight(true) * 1.1 : '85%',
                    triggerHook: 0.65,
                })
                    .setClassToggle($this.get(0), 'effect')
                    // .addIndicators()
                    .addTo(controller);
            });
        }
        else {
            $('.slanted-wrapper').each(function () {
                $(this).addClass('effect');
            });
        }
        // $('.cause').each(function () {
        //     var $this = $(this);
        //     var scene = new ScrollMagic.Scene({
        //             triggerElement: $this.get(0),
        //             duration: '700',
        //             triggerHook: 0.65,
		// 			offset: 50, // move trigger to center of element
		// 			reverse: true // only do once
        //            })
        //         .setClassToggle($this.get(0), 'effect')
        //         // .addIndicators()
        //         .addTo(controller);
        // });
    });

})( jQuery );